<template>
    <div class="d-center">
    <span v-if="leftText&&mode==0" :class="[required ? 'text-danger':'text-white','mr-small']">*</span>
    <div class="d-center" v-if="leftText&&mode==0" ><div class="form-left-text" :style="{width:width+'px'}">{{leftText}}</div>：</div>
    <div class="  input-self-border" style="text-align:left;" >
        <div style="display: flex" class="input">
            <input
                    :disabled="disabled"
                    :value="myValue"
                    :placeholder="tip"
                    @input="input($event)"
                    @blur="blur($event)"
                    @change="change($event)"
            >
            <div class="clear" @click="clear()" v-if="myValue!=''">清空</div>
        </div>
    </div>
    <div class=" vrs" v-if="mode==1">{{leftText}}</div>
  </div>
</template>
<script>
    export default {
        name: "s-inputNumber",
        props: {
            value: {},
            width: {
                type: Number,
                default:100
            },
            required: {
                type: Boolean,
                default: false
            },
            step: {
                type: Number,
                default: 1
            },
            leftText: {
                type: String,
            },
            max: {
                type: Number,
                default: Infinity
            },
            min: {
                type: Number,
                default: -Infinity
            },
            disabled: Boolean,
            controls: {
                type: Boolean,
                default: true
            },
            tip: String,
            precision: {
                type: Number,
                validator(val) {
                    return val >= 0 && val === parseInt(val, 10);
                },
                default: 0
            },
            mode:{
                type: Number,
                default: 0
            },
        },
        computed: {
            myValue() {
                let val = this.value === null ? '' : this.value.toString()
                // 清除"数字"和"."以及"-"以外的字符
                val = val.replace(/[^\d.]/g, '')//val.replace(/[^\-\d.]/g, '')
                // 只保留第一个“点”号, 清除多余的
                const idx = val.indexOf('.')
                if (!(idx === -1 || idx === val.length - 1)) {
                    val = val.substr(0, idx) + '.' + val.substr(idx + 1).replace(/\./g, '')
                }
                // 只保留首位的负号, 清除多余的
                if (val.length > 1) {
                    val = val.replace(/0*(\d+)/,'$1')
                }
                // 将 '-.' 替换成 '-0.'
                val = val.replace(/^\./g, '0.').replace(/^-\./, '-0.').replace(/^\0/g, '0.')
                const str = '^(\\-)*(\\d+)\\.(\\d{' + this.precision + '}).*$';
                // if(val.length==1&&val==0){
                //     val='0.'
                // }
                const reg = new RegExp(str)
                if (this.precision === 0) {
                    // 不需要小数点
                    val = val.replace(reg, '$1$2')
                } else {
                    // 通过正则保留小数点后指定的位数
                    val = val.replace(reg, '$1$2.$3')
                }
                // 限制输入最大值
                if(val>this.max){
                    val=this.max
                }
                // 限制输入最小值
                let min= this.min.toString();
                console.log(val.length,min.length)
                if(val.length==min.length&&val<this.min){
                    val=this.min
                }
                console.log(val);
                this.$emit('input', val)
                this.$emit('blur', val)
                return val
            }
        },
        methods: {
            blur($event) {
                // console.log($event);
                // let val = Number($event.target.value)
                // // 只输入负号或未输入时，默认显示最小值
                // if (isNaN(val) || val === '') {
                //     val = this.min
                // }
                // if (val < this.min) {
                //     val = this.min
                // }
                // if (val > this.max) {
                //     val = this.max
                // }
                // this.$emit('input', val)
                // this.$emit('blur', val)
            },
            input($event) {
                this.$emit('input', $event.target.value)
            },
            change($event) {
                this.$emit('change', $event.target.value)
            },
            //清空输入框
            clear(){
                console.log('111')
                this.$emit('input','')
                this.$emit('blur','')
            },
        }
    }
</script>

<style scoped lang="scss">
    .narrow{
    input{
      height: 24px!important;
    }
  }
  .smallInput{
    height: 24px!important;
    line-height: 24px!important
  }
  .input-self-border {
    width: 100%;
    box-sizing: border-box;
    color: #606266;
    flex: 1;
    input,textarea{
      border: 1px solid #dcdfe6;
      padding: 3px 0px;
      appearance: none;
      width: 94%;
      padding: 0 3%;
      border-radius: 3px;
      font-size: 14px;
      line-height: 32px;
      &:focus{

        outline: none;
        border: 1px solid #26a2ff;
      }
    }
    input{height: 40px;color: #606266; border-radius: 4px;}
    textarea{
      height: 80px;
      resize: none;
    }
  }
  .append{
    background-color: #f5f7fa;
    vertical-align: middle;
    display: table-cell;
    position: relative;
    border: 1px solid #dcdfe6;
    border-left: 0;
    font-size: 14px;
    padding: 3px 0;
    border-radius: 4px;
    width: 60px;
    white-space: nowrap;
    height: 24px;
    line-height: 24px;
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
    text-align: center
  }
  .input{
   position: relative;
  }
  .clear{
    position: absolute;
    height: 40px;
    line-height: 40px;
    top: 0;
    right: 10px;
    font-size: 12px;
    color: #999;
    cursor: pointer;
  }
  .vrs{
    width:65%;
    text-align: left;
    padding: 0;
    margin: 0;
    display: block;
    line-height: 40px;
    padding: 0 10px;
  }
  .smalloen{
    width: 20%;
  }
</style>